/**
 * Utility to help formatting of carm angles
 */

export type CArmAxis = 'craniocaudal' | 'oblique';

const CARM_ANGLES_SUFFIX_MAP: Record<CArmAxis, [string, string]> = {
    craniocaudal: ['CRA', 'CAU'],
    oblique: ['LAO', 'RAO'],
};

/**
 * Format a single CARM angle value with direction label.
 * @param value - Angle value (positive or negative)
 * @param axis - The rotation axis
 * @returns Formatted angle e.g. "CRA 15.5°"
 */
export const formatCarmAngle = (value: number, axis: CArmAxis): string => {
    if (isNaN(value)) return 'N/A';

    const [positive, negative] = CARM_ANGLES_SUFFIX_MAP[axis];
    const label = value < 0 ? negative : positive;

    return `${label} ${Math.abs(value).toFixed(1)}°`;
};
